import ActionType from './action-type'
import * as Actions from './actions'
import * as uuid from 'uuid'
import {type ThunkAction} from 'redux-thunk'

import {Api, type QuerySpecification} from '../../../api/Api'
import {type QueryCancellation} from '../../../websocket/Queries'
import {type AppState} from '../../types/app-state'
import {type LatestLocationThreatScores} from './state'

const QUERY_PATH = 'latestLocationThreatScores'
const QUERY_SCHEDULE = '15s'

function latestLocationThreatScoresQuery(): QuerySpecification {
    return {
        path: QUERY_PATH,
        localId: `${QUERY_PATH}-${uuid.v4()}`,
        schedule: QUERY_SCHEDULE,
    }
}

export function registerLatestLocationThreatScoresQuery(): ThunkAction<
    void,
    AppState,
    Api,
    Actions.Action
> {
    return (dispatch, _, api: Api): QueryCancellation => {
        dispatch(requestLatestLocationThreatScores())

        const query: QuerySpecification = latestLocationThreatScoresQuery()

        api.newQuery(query, (data) => {
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            dispatch(receiveLatestLocationThreatScores((data as LatestLocationThreatScores) ?? {}))
        })

        return () => {
            api.cancelQuery({localId: query.localId})
        }
    }
}

export function requestLatestLocationThreatScores(): Actions.RequestLatestLocationThreatScoresAction {
    return {
        type: ActionType.REQUEST_LATEST_LOCATION_THREAT_SCORES,
    }
}

/**
 * CDS-6008. Clears the loading flag without touching the scores, so a failed
 * fetch stops the consumers spinning and leaves whatever was last received on
 * screen.
 */
export function latestLocationThreatScoresRequestFailed(): Actions.LatestLocationThreatScoresRequestFailedAction {
    return {
        type: ActionType.LATEST_LOCATION_THREAT_SCORES_REQUEST_FAILED,
    }
}

export function receiveLatestLocationThreatScores(
    latestLocationThreatScores: LatestLocationThreatScores,
): Actions.ReceiveLatestLocationThreatScoresAction {
    return {
        type: ActionType.RECEIVE_LATEST_LOCATION_THREAT_SCORES,
        payload: latestLocationThreatScores,
    }
}
